import axios from "axios";
import dayjs from "dayjs";
import Cookies from "js-cookie";
import { getSession } from "./utility/SessionManager";
import constants from "./common/constants";
import Methods from "./utility/Methods";

const getAuthToken = () => {
  return Methods.decryptData(
    getSession(window, constants.SS_KEY_GROUP_ACCESS_TOKEN)
  );
};

axios.defaults.headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

export const renewalDashboardAxios = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL_WITH_GATEWAY_RENEWALDASHBOARD,
});

export const fetchDataAxios = axios.create({
  baseURL: process.env.REACT_APP_ABHA_BACKEND_URL,
});

export const fetchDataWithTokenAxios = axios.create({
  baseURL: process.env.REACT_APP_ABHA_BACKEND_URL,
});
export const fetchDataWithTokenForPdfAxios = axios.create({
  baseURL: process.env.REACT_APP_ABHA_BACKEND_URL,
});

// export const fetchUploadDataAxios = axios.create({
//   baseURL: process.env.REACT_APP_ABHA_BACKEND_URL,
// });

// export const fetchDataLeadAxios = axios.create({
//   baseURL: process.env.REACT_APP_ABHA_BACKEND_URL,
// });

const updateAuthToken = async (config) => {
  const authToken = getAuthToken().replace(/^"|"$/g, "");
  config.headers["Authorization"] = `Bearer ${authToken}`;
  return config;
};

fetchDataAxios.interceptors.request.use(
  async (config) => {
    // config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    config.headers["Accept"] = "application/json";
    // config.headers["Access-Control-Allow-Origin"] = "*";
    return config;
  },
  (error) => {
    console.log("error");
    Promise.reject(error);
  }
);
fetchDataWithTokenAxios.interceptors.request.use(
  async (config) => {
    // config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    config.headers["Accept"] = "application/json";
    // config.headers["Access-Control-Allow-Origin"] = "*";
    return updateAuthToken(config);
  },
  (error) => {
    console.log("error");
    Promise.reject(error);
  }
);

fetchDataWithTokenForPdfAxios.interceptors.request.use(
  async (config) => {
    config.headers["Accept"] = "application/pdf";
    return updateAuthToken(config);
  },
  (error) => {
    console.log("error", error);
    Promise.reject(error);
  }
);

// fetchUploadDataAxios.interceptors.request.use(
//   async (config) => {
//     config.headers["Accept"] = "application/json";
//     config.headers["Access-Control-Allow-Origin"] = "*";
//     config.headers["Content-Type"] = "multipart/form-data";
//     return updateAuthToken(config);
//   },
//   (error) => Promise.reject(error)
// );

// function invalidUserResponse() {
//   Cookies.remove("manipalcigna_user_token");
//   window.location.replace("/distribution-portal/session-expired");
// }
